import React, { createContext, useState, useContext, useEffect } from "react";
import { BASE_URL } from "../Config";

const AuthContext = createContext();

export const JWTAuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem("jwtToken"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("jwtToken");

    if (storedToken) {
      setAuthToken(storedToken);
    }
    setLoading(false);
  }, []);

  const login = (jwtToken) => {
    localStorage.setItem("jwtToken", jwtToken);
    setAuthToken(jwtToken);
  };

  const logout = () => {
    localStorage.removeItem("jwtToken");
    setAuthToken(null);
  };

  // Check if the user is authenticated
  const isAuthenticated = !!authToken;

  // Auth context value
  const authContextValue = {
    authToken,
    isAuthenticated,
    login,
    logout,
    loading,
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const SessionAuthProvider = ({ children }) => {
  // State to store the auth token and loading state
  const [authToken, setAuthToken] = useState(localStorage.getItem("loggedin"));
  const [loading, setLoading] = useState(true);

  // Load token from cookies on initial load
  useEffect(() => {
    const token = localStorage.getItem("loggedin");
        
    // check if we are logged in
    const fetchAsync = async () => {
      const response = await fetch(`${BASE_URL}/webapp/profile`, {
        method: 'GET',
        headers: {"Content-Type": "application/json"},
        credentials: 'include'
      });
      if(response.status === 200){
        const data = await response.json();
        if(data.username){
          setAuthToken(true);
        }else{
          setAuthToken(false);
        }
        setLoading(false); // Finished loading after token retrieval attempt
      }
    }
    fetchAsync();

  }, []);
  
  // Login function to set the auth token
  const login = () => {
    localStorage.setItem("loggedin", true);
    setAuthToken(true);
  };
  
  // Logout function to remove the auth token
  const logout = () => {
    localStorage.removeItem("loggedin");
    setAuthToken(null);
  };

  // Check if the user is authenticated
  const isAuthenticated = !!authToken;

  // Auth context value
  const authContextValue = {
    authToken,
    isAuthenticated,
    login,
    logout,
    loading,
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {!loading && children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => {
  return useContext(AuthContext);
};
